import { useMemo } from 'react';
import { getVertices } from '../../components/snapping/utils';
import type { StageFrameData } from '../stage-provider';
import type { StageAnnotation } from '../stage-provider/types';
const useSnap = (frameData?: StageFrameData<StageAnnotation>) => {
  const annotationStore = frameData?.annotationStore;
  const snapPoints = useMemo(() => {
    if (!annotationStore) {
      return {
        x: [],
        y: []
      };
    }
    const setX = new Set<number>();
    const setY = new Set<number>();
    Object.keys(annotationStore).forEach(annotationIdx => {
      const annotation = annotationStore[annotationIdx];
      // @ts-expect-error todo(ts-migration) TS2345 Argument of type 'StageAnnotation | undefined' is not assignable to parameter of type 'AnnotationT'.
      const vertices = getVertices(annotation);
      vertices.forEach(({
        point
      }) => {
        setX.add(point[0]);
        setY.add(point[1]);
      });
    });
    return {
      x: [...setX],
      y: [...setY]
    };
  }, [annotationStore]);
  return {
    snapPoints
  };
};
export default useSnap;